import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "progress",
  computed: {
    styleSuffixName: function styleSuffixName() {
      return {
        fontWeight: this.option.suffixFontWeight || "normal",
        fontSize: (this.option.suffixFontSize || 40) + "px",
        color: this.option.suffixColor || "#333"
      };
    },
    styleName: function styleName() {
      return {
        marginBottom: this.option.split + "px",
        fontWeight: this.option.fontWeight || "normal",
        fontSize: (this.option.fontSize || 40) + "px",
        color: this.option.color || "#333"
      };
    },
    type: function type() {
      return this.option.type || "line";
    },
    color: function color() {
      return this.option.borderColor || "#333";
    },
    strokeWidth: function strokeWidth() {
      return this.option.strokeWidth || 14;
    }
  },
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.clickFormatter && this.clickFormatter({
        data: this.dataChart
      }, this.getItemRefs());
    }
  }
});